/*
 * @Author: soji
 * @Description: 全局对量
 * @Date: 2024-06-25 17:47:10
 */
import Vue from 'vue';
let Com = {
  showToast: function(content, duration = 2000) {


    const createLoadingEl = function() {
      let elDiv = document.getElementById('toastId')
      if(!elDiv) {
  
        elDiv = document.createElement('div');
        elDiv.id = 'toastId'
        elDiv.innerHTML = [
          `<section class="toast-box" v-show="showToast">` +
            `<section class="toast-box-content">` +
              `<p id="toast-content-id">` + 
                content +
              `</p>` +
            `</section>` +
          `</section>`
        ].join("");
      }
  
      return elDiv;
    }

    var elBody =document.getElementsByTagName("body")[0];
    let elDiv = document.getElementById('toastId');
    if(elDiv) {
      let contentEl = document.getElementById('toast-content-id')
      contentEl.innerText = content
      elDiv.style.display = 'block';
    }else {
      elDiv = createLoadingEl();
      elBody.appendChild(elDiv);
    }
    setTimeout(() => {
      elDiv.style.display = 'none';
    }, duration);
  }

  
}

export default Com;


// WEBPACK FOOTER //
// ./plugins/Com.js